import styled from "styled-components";

export const SaleCampaignBannerContainer = styled.div`
	width: 100%;
	height: calc(100vh - 150px);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	position: relative;
	background: #fff;

	@media screen and (max-width: 990px) {
		height: 300px !important;
	}

	@media screen and (max-width: 769px) {
		height: 250px !important;
		padding-top: 30px;
	}

	@media screen and (max-width: 520px) {
		height: 230px !important;
		padding-top: 10px;
	}
`;

export const CampaignBanner = styled.div`
	display: block;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	.campaign-banner-img {
		display: inline-block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	@media screen and (max-width: 520px) {
		.campaign-banner-img {
			object-fit: contain;
		}
	}
`;

export const SaleCampaignTimerWrapper = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	&.disabled {
		display: none;
	}

	.timer-title {
		display: block;
		font-size: 3rem;
		color: #9cc54b;
		text-shadow: 1.25px 1.25px #4b4a49;
		border-radius: 0.25rem;
		margin-bottom: 0.25rem;
	}

	.timer-content {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1.5rem;

		.divider {
			width: max-content;
			height: 12rem;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 3rem;

			.dot {
				width: 1rem;
				height: 1rem;
				border-radius: 50%;
				background: #9cc54b;
			}
		}

		.timer-item-wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;

			.timer-number {
				font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
					Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif !important;
				display: inline-block;
				font-weight: 700;
				font-size: 8rem;
				color: #9cc54b;
				width: 12rem;
				height: 9rem;
				text-align: center;
				background: rgb(248, 249, 250, 0.75);
				display: grid;
				place-content: center;
				border-radius: 0.25rem 0.25rem 0 0;
				box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
					rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
				text-shadow: 1.25px 1.25px #4b4a49;
			}

			.timer-label {
				color: #fff;
				text-shadow: 1.25px 1.25px #4b4a49;
				font-weight: 900;
				font-size: 2rem;
				width: 12rem;
				height: 3rem;
				display: grid;
				place-content: center;
				background: rgb(156, 197, 75, 0.75);
				border-radius: 0 0 0.25rem 0.25rem;
				padding: 0.125rem;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.timer-title {
			font-size: 1.75rem;
		}

		.timer-content {
			.divider {
				height: 9rem;
				gap: 2.5rem;
			}

			.timer-item-wrapper {
				.timer-number {
					width: 9rem;
					height: 7rem;
					font-size: 6rem;
				}

				.timer-label {
					width: 9rem;
					height: 2rem;
					font-size: 1rem;
				}
			}
		}
	}

	@media screen and (max-width: 990px) {
		.timer-content {
			gap: 1rem;

			.divider {
				height: 7rem;
				gap: 2rem;

				.dot {
					width: 0.75rem;
					height: 0.75rem;
				}
			}

			.timer-item-wrapper {
				.timer-number {
					width: 7rem;
					height: 5.25rem;
					font-size: 5rem;
				}

				.timer-label {
					width: 7rem;
					height: 1.75rem;
					font-size: 1rem;
				}
			}
		}
	}

	@media screen and (max-width: 780px) {
		.timer-title {
			font-size: 1.5rem;
		}

		.timer-content {
			.divider {
				height: 5rem;
				gap: 1.5rem;

				.dot {
					width: 0.5rem;
					height: 0.5rem;
				}
			}

			.timer-item-wrapper {
				.timer-number {
					width: 5rem;
					height: 3.75rem;
					font-size: 3.5rem;
				}

				.timer-label {
					width: 5rem;
					height: 1.25rem;
					font-weight: 500;
					font-size: 0.75rem;
				}
			}
		}
	}

	@media screen and (max-width: 540px) {
		.timer-title {
			font-size: 1.25rem;
			margin-bottom: 0.125rem;
		}

		.timer-content {
			gap: 0.5rem;

			.divider {
				height: 4rem;
				gap: 0.85rem;

				.dot {
					width: 0.35rem;
					height: 0.35rem;
				}
			}

			.timer-item-wrapper {
				.timer-number {
					width: 4rem;
					height: 2.75rem;
					font-size: 2.35rem;
				}

				.timer-label {
					width: 4rem;
					height: 1.25rem;
					font-weight: normal;
					font-size: 0.725rem;
				}
			}
		}
	}

	@media screen and (max-width: 375px) {
		.timer-title {
			font-size: 1rem;
		}

		.timer-content {
			gap: 0.5rem;

			.divider {
				height: 3.25rem;
				gap: 0.75rem;

				.dot {
					width: 0.3rem;
					height: 0.3rem;
				}
			}

			.timer-item-wrapper {
				.timer-number {
					width: 3.25rem;
					height: 2.25rem;
					font-size: 1.75rem;
				}

				.timer-label {
					width: 3.25rem;
					height: 1rem;
					font-size: 0.65rem;
				}
			}
		}
	}
`;

export const SmallSaleCampaignTimerWrapper = styled.div`
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	gap: 0.5rem;

	.divider {
		width: max-content;
		height: 3.25rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 0.75rem;

		.dot {
			display: block;
			width: 0.3rem;
			height: 0.3rem;
			border-radius: 50%;
			background: #9cc54b;
		}
	}

	.timer-item-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;

		.timer-number {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
				Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif !important;
			display: inline-block;
			font-weight: 700;
			font-size: 2rem;
			width: 3.25rem;
			height: 2.25rem;
			text-align: center;
			background: #9cc54b;
			color: #fff;
			display: grid;
			place-content: center;
			border-radius: 0.25rem 0.25rem 0 0;
			box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
				rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
			text-shadow: 1.25px 1.25px #4b4a49;
		}

		.timer-label {
			color: #fff;
			text-shadow: 1.25px 1.25px #4b4a49;
			font-size: 0.65rem;
			width: 3.25rem;
			height: 1rem;
			display: grid;
			place-content: center;
			background: #4b4a49;
			border-radius: 0 0 0.25rem 0.25rem;
		}
	}

	@media screen and (max-width: 769px) {
		gap: 0.5rem;

		.divider {
			height: 3rem;
			gap: 0.5rem;

			.dot {
				width: 0.25rem;
				height: 0.25rem;
			}
		}

		.timer-item-wrapper {
			.timer-number {
				font-size: 1.75rem;
				width: 3rem;
				height: 2rem;
			}

			.timer-label {
				font-size: 0.55rem;
				width: 3rem;
				height: 1rem;
			}
		}
	}
`;

export const CampaignDescriptions = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	background: #fff;
	cursor: pointer;

  .campaign-logo {
    display: block;
    width: 90px;
    height: 90px;
    aspect-ratio: 1/1;
    object-fit: contain;

    &.main {
      width: 100px;
      height: 100px;
    }
  }

	.count-down-content {
		display: flex;
		align-items: center;
		gap: 1rem;
		border-left: 1px solid #4b4a49;
		padding-left: 1rem;

		.campaign-promotion-end-in-label {
			display: block;
			font-size: 1rem;
			font-weight: 500;
			color: #4b4a49;
		}
	}

	@media screen and (max-width: 769px) {
		flex-direction: column;
		gap: 0;

		.count-down-content {
			border-left: none;
			padding-left: 0;
			flex-direction: column;
			gap: 0.5rem;
		}
	}
`;

export const SaleCampaignPageContainer = styled.div`
	box-sizing: border-box;
	height: max-content;
	display: grid;
	// place-items: center;
	padding: 69px 0 0 0;

	@media (max-width: 991px) {
		padding-top: 25px;
	}
`;

export const PageWrapper = styled.div`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	min-height: 100vh;
	margin: 0 auto;
	display: flex;
	// background: #ffffff;
	// margin-top: 60px;
	// padding-bottom: 30px;
`;

export const SaleCampaignHeader = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.75rem 2.25rem;

	.campaign-title {
		display: inline-block;
		font-size: clamp(1.4rem, 3vw, 1.15rem);
		font-weight: 600;
	}

	.total-items-count {
		display: block;
		margin-left: auto;
	}

	@media screen and (max-width: 576px) {
		padding: 0.5rem;

		.campaign-title {
			font-size: 1.025rem;
		}
	}
`;

export const Title = styled.div`
	display: block;
	font-size: 2rem;
	font-weight: 500;
	color: #28a745;
`;

export const SaleCampaignItemWrapper = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(342px, 1fr));
	gap: 0.75rem;
	padding: 0.75rem 2.25rem;
	background: #f8f9fa;

	@media screen and (max-width: 576px) {
		gap: 0.5rem;
		padding: 0.5rem;
	}
`;

export const SaleCampaignItemContent = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: stretch !important;
	gap: clamp(0.625rem, 5vw, 0.5rem);
	padding: 0.625rem;
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	border-radius: inherit;
	background: #ffffff;
	border-radius: 0.25rem;

	.btn-favorite {
		z-index: 9;
		position: absolute;
		top: clamp(0.625rem, 5vw, 0.5rem);
		right: clamp(0.625rem, 5vw, 0.5rem);
		width: 30px;
		height: 30px;
		border-radius: 30px;
		display: grid;
		place-content: center;

		.favorite-icon,
		.favorites-spinner {
			color: #9cc54b;
		}
	}
	&.express .btn-favorite {
		.favorite-icon,
		.favorites-spinner {
			color: #f01266;
		}
	}
`;

export const ImageContent = styled.div`
	position: relative;
	display: gird;
	place-content: center;
	width: clamp(150px, 5vw, 100px);
	// height: clamp(105px, 5vw, 65px)
	cursor: pointer;

	img {
		display: block;
		width: 100%;
		height: 100%;
		aspect-ratio: 3/4;
		object-fit: contain;
	}

	@media screen and (max-width: 520px) {
		width: clamp(125px, 5vw, 100px);
	}
`;

export const BrandLogoWrapper = styled.div`
	height: 35px;
	width: 35px;
	position: absolute;
	z-index: 1;
	top: 0px;
	left: 0px;
	border-radius: 50%;
	border: 1px solid rgb(236, 236, 236);
	display: grid;
	place-items: center;

	img {
		display: inline-block;
		height: 33px;
		width: 33px;
		border-radius: 50%;
		aspect-ratio: 3/4;
		object-fit: contain;
		mix-blend-mode: color-burn;
	}
	.brand-image {
		max-height: 35px;
		width: auto;
	}
	.brand-promo {
		max-height: 35px;
		width: auto;
	}
`;

export const ItemInfo = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;

	.stock-and-sku {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		column-gap: 0.5rem;
		flex-wrap: wrap;

		.stock-label,
		.sku-label {
			font-size: 0.875rem;
			span {
				font-size: 0.875rem;
				color: #9cc54b;
				font-weight: 500;

				&.express {
					color: #f01266;
				}
			}
		}

		@media (max-width: 450px) {
			.stock-label,
			.sku-label {
				font-size: 0.625rem;
				span {
					font-size: 0.625rem;
				}
			}
		}
	}
`;

export const BannerWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;
	margin-bottom: 5px;

	span {
		padding: 0px 5px;
		color: #ffffff;
		font-size: 10px;
		line-height: 1.7;
		border-radius: 2px;

		&.sameDay-banner {
			background: #9cc54b;

			&.express {
				background: #f01266;
			}
		}

		&.tomorrow-banner {
			background: #fd7e14;
		}

		&.promo-banner {
			background: #dc3545;
		}

		&.out-of-stock-banner {
			background: #dc3545;
		}
	}
`;

export const ItemTitle = styled.p`
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.25;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	cursor: pointer;
	word-break: break-word;
	padding-right: 1.75rem;

	@media (max-width: 450px) {
		line-height: 1.25;
		font-size: 0.925rem;
	}
`;

export const WeightAndCountryWrapper = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 1rem;
	font-size: 0.925rem;
	color: #6c757d;

	@media (max-width: 450px) {
		// font-size: 0.75rem;
		gap: 0.5rem;
	}
`;

export const PriceAndButtonActions = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	gap: 0.25rem;
	margin-top: auto;

	.btn-add-to-cart {
		transition: 0.3s;

		&:hover {
			background: #ffffff !important;
			color: #9cc54b !important;
			border-color: #9cc54b;
			& > * {
				fill: #9cc54b;
			}

			&.express {
				color: #f01266 !important;
				border-color: #f01266;
				& > * {
					fill: #f01266;
				}
			}
		}
	}
`;

export const ProductPriceWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.175rem;
	flex-shrink: 0;
	// margin-top: auto;

	// .price {
	// 	font-size: clamp(1.075rem, 3vw, 1rem) !important;
	// }
`;

export const ProductPrice = styled.span`
	font-family: "Lato", sans-serif;
	font-size: clamp(1rem, 5vw, 0.75rem);
	// font-weight: bold;
	color: #6c757d;

	&.express {
		color: #6c757d;
	}

	span {
		color: #6c757d;

		&.express {
			color: #6c757d;
		}
	}
`;

export const PromoPrice = styled.span`
	font-family: "Lato", sans-serif;
	font-size: clamp(1.35rem, 5vw, 0.85rem);
	font-weight: bold;
	color: #9cc54b;
	display: inline-block;
`;

export const SpinnerWrapper = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	padding: 1rem;
`;

export const EmptyCampaignProductContent = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	padding-bottom: 4rem;

	.empty-campaign-title {
		font-size: 1.25rem;
		font-weight: 600;
	}
`;

export const IconCartContainer = styled.span`
	width: 14px;
	height: 14px;
	display: flex;
	align-items: center;
	fill: #fff;
`;
